document.documentElement.classList.remove('no-js');

const header = document.querySelector('[data-site-header]');
if (header) {
  const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
}

document.querySelectorAll('.ml-faq details').forEach((item) => {
  item.addEventListener('toggle', () => {
    if (!item.open) return;
    document.querySelectorAll('.ml-faq details[open]').forEach((other) => {
      if (other !== item) other.removeAttribute('open');
    });
  });
});

document.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
  const slides = [...carousel.querySelectorAll('[data-hero-slide]')];
  const dots = [...carousel.querySelectorAll('[data-hero-dot]')];
  const previous = carousel.querySelector('[data-hero-prev]');
  const next = carousel.querySelector('[data-hero-next]');
  if (slides.length < 2) return;
  let current = 0;
  let timer;
  const delay = Number(carousel.dataset.delay) || 6000;
  const autoplay = carousel.dataset.autoplay === 'true';

  const show = (index) => {
    current = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === current;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
    });
    dots.forEach((dot, dotIndex) => {
      const active = dotIndex === current;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', String(active));
    });
  };
  const stop = () => window.clearInterval(timer);
  const start = () => {
    stop();
    if (autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      timer = window.setInterval(() => show(current + 1), delay);
    }
  };
  previous?.addEventListener('click', () => { show(current - 1); start(); });
  next?.addEventListener('click', () => { show(current + 1); start(); });
  dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); start(); }));
  carousel.addEventListener('mouseenter', stop);
  carousel.addEventListener('mouseleave', start);
  carousel.addEventListener('focusin', stop);
  carousel.addEventListener('focusout', start);
  start();
});

document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
  const rail = carousel.querySelector('[data-product-rail]');
  const previous = carousel.querySelector('[data-product-rail-prev]');
  const next = carousel.querySelector('[data-product-rail-next]');
  if (!rail || !previous || !next) return;

  const update = () => {
    const remaining = rail.scrollWidth - rail.clientWidth - rail.scrollLeft;
    previous.disabled = rail.scrollLeft <= 2;
    next.disabled = remaining <= 2;
  };
  const amount = () => {
    const cardWidth = rail.querySelector('.ml-product-card')?.getBoundingClientRect().width || 0;
    if (window.matchMedia('(min-width: 1101px)').matches) return rail.clientWidth;
    return Math.max(rail.clientWidth * 0.82, cardWidth);
  };
  const move = (direction) => rail.scrollBy({ left: direction * amount(), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });

  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  rail.addEventListener('scroll', update, { passive: true });
  rail.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
  });
  rail.querySelectorAll('img').forEach((image) => image.addEventListener('load', update, { once: true }));
  new ResizeObserver(update).observe(rail);
  requestAnimationFrame(update);
});

const sizeNavigationPanels = () => {
  const header = document.querySelector('.am-header');
  if (!header) return;
  const nav = header.querySelector('.am-core-nav');
  const mobilePanel = header.querySelector('.am-mobile-menu[open] .am-mobile-menu__panel');
  if (nav) header.style.setProperty('--am-menu-top', `${Math.max(0, nav.getBoundingClientRect().bottom)}px`);
  if (mobilePanel) header.style.setProperty('--am-mobile-menu-top', `${Math.max(0, mobilePanel.getBoundingClientRect().top)}px`);
};
window.addEventListener('resize', sizeNavigationPanels);
document.querySelectorAll('.am-mobile-menu').forEach((menu) => menu.addEventListener('toggle', sizeNavigationPanels));
document.querySelectorAll('.am-nav-item').forEach((item) => {
  // The department name remains a direct link; pointer users can browse subcategories on hover.
  item.addEventListener('mouseenter', () => {
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) item.open = true;
  });
  item.addEventListener('mouseleave', () => {
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && !item.matches(':focus-within')) item.open = false;
  });
  item.addEventListener('toggle', () => {
    if (!item.open) return;
    sizeNavigationPanels();
    document.querySelectorAll('.am-nav-item[open]').forEach((other) => {
      if (other !== item) other.removeAttribute('open');
    });
  });
});

document.addEventListener('click', (event) => {
  if (!event.target.closest('.am-nav-item')) document.querySelectorAll('.am-nav-item[open]').forEach((item) => item.removeAttribute('open'));
});

document.querySelectorAll('[data-language-filter]').forEach((input) => {
  input.addEventListener('input', () => {
    const query = input.value.trim().toLowerCase();
    input.closest('[data-language-picker]')?.querySelectorAll('[data-language-option]').forEach((option) => {
      option.hidden = query.length > 0 && !option.dataset.search.includes(query);
    });
  });
});

document.querySelectorAll('.am-mobile-menu').forEach((menu) => {
  menu.querySelector('[data-mobile-close]')?.addEventListener('click', () => menu.removeAttribute('open'));
  menu.querySelectorAll('.am-mobile-department').forEach((department) => {
    department.addEventListener('toggle', () => {
      if (!department.open) return;
      menu.querySelectorAll('.am-mobile-department[open]').forEach((other) => {
        if (other !== department) other.removeAttribute('open');
      });
    });
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.am-nav-item[open], .am-language[open], .am-mobile-menu[open]').forEach((item) => item.removeAttribute('open'));
});

document.querySelectorAll('[data-design-visualizer]').forEach((visualizer) => {
  const controls = visualizer.querySelectorAll('[data-visualizer-tab]');
  const views = visualizer.querySelectorAll('[data-visualizer-view]');

  const showView = (name) => {
    views.forEach((view) => { view.hidden = view.dataset.visualizerView !== name; });
    controls.forEach((control) => {
      const active = control.dataset.visualizerTab === name;
      control.setAttribute('aria-selected', String(active));
      control.setAttribute('aria-pressed', String(active));
    });
  };

  controls.forEach((control) => control.addEventListener('click', () => showView(control.dataset.visualizerTab)));
});
